import { extractRootHtmlElement as a } from "@scalar-org/vue-render";
import { resolveAndFetchIcon as l } from "./resolveAndFetchIcon.js";
async function g(t) {
  const n = typeof t.src == "object" ? t.src.src : t.src;
  if (!n) return "";
  const c = await l(n), i = [...t.classes || []];
  if (c) {
    const e = a(c);
    if (e.tagName === "svg") {
      const s = e.properties;
      return s.width = t.size || e.properties.width || "1em", s.height = t.size || e.properties.height || "1em", i.length && (s.class = i.join(" ")), `
      <svg ${Object.entries(s).map(([r, o]) => `${r}="${o}"`).join(" ")}>${e.innerHTML}</svg>
      `.trim();
    }
  }
  return `
<img
  src="${t.src}"
  alt="${t.title ?? "Icon"}"
  style="${t.size ? `width: ${t.size}; height: ${t.size}; object-fit: contain;` : "object-fit: contain;"}"
  onerror="this.style.visibility='hidden'" ${i.length ? `class="${i.join(" ")}" ` : ""}/>
`.trim();
}
export {
  g as guideIconHtml
};
